// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1292":"abd52210","6690":"782f1aa0"}[chunkId] + ".chunk.css";
};